<app-loader *ngIf="isDisabled"></app-loader>
<div class="modal-header">
    <span class="modal-title">Employee List</span>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
</div>
<div class="modal-body">
    <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
        <div class="row mx-1">
            <div class="col-md-4">
                <label for="Empcode" class="text-label-dark">Employee Code</label>
                <input type="text" class="form-control" placeholder="Ex. Emp001" id="Empcode" name="Empcode"
                    [(ngModel)]="Filter.Empcode" #Empcode="ngModel" maxlength="100">
            </div>
            <div class="col-md-4">
                <label for="EmpName" class="text-label-dark">Employee Name</label>
                <input type="text" class="form-control" placeholder="Ex. John" id="EmpName" name="EmpName"
                    pattern="[a-zA-Z ]*" [(ngModel)]="Filter.EmpName" #EmpName="ngModel" maxlength="100">
            </div>
            <div class="col"></div>
            <div class="col-md-auto align-content-center">
                <button class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-people me-2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Get Employee':'Loading...'}}</button>
            </div>
        </div>
    </form>
    <div class="row mt-2">
        <div class="col-12">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th>Employee</th>
                        <th>EmpType</th>
                        <th><span style="width: max-content;" class="d-block">Declaration</span></th>
                        <th><span style="width: max-content;" class="d-block">Investment</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of EmpData; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 100%;">
                            <span style="width: max-content;" class="d-block">
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(TableData['Photo'])" />
                                        <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(TableData['Name'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <span class="text-label">{{TableData['Name']}}</span><br />
                                        <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                        <span class="text-label-light">{{TableData['Designation']}}</span>
                                    </div>
                                </div>
                            </span>
                        </td>
                        <td>{{TableData['Emptype']}}</td>
                        <td class="cursor-pointer"><span style="width: max-content;" class="d-block"
                                (click)="OpenDeclarionInvestment('D',TableData['EmpMasterID'])">
                                <span class="badge success">Add
                                    Declaration</span></span></td>
                        <td class="cursor-pointer"><span style="width: max-content;" class="d-block"
                                (click)="OpenDeclarionInvestment('E',TableData['EmpMasterID'])">
                                <span class="badge success">Add Investment</span></span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="close(false)"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Close':'Loading...'}}</button>
</div>